import instance from "@/utils/require.js"

// 登录页--用户登录
export function apiCacheFlushAll(data = {}) {
	return instance({
		url: "/aim/api/v3/cache/flush_all",
		method: "post",
		data
	})
}